import paths from '@/router/paths';
export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      window.getApp.snackbar = {
        show: true,
        color: 'success',
        text: 'Đăng nhập thành công'
      };
      setTimeout(() => window.getApp.$router.replace('/'), 100);
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      window.getApp.snackbar = {
        show: true,
        color: 'success',
        text: 'Đăng xuất thành công'
      };
      window.getApp.$store.commit('authentication/clearToken');
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      localStorage.clear();
      setTimeout(() => window.getApp.$router.replace('/dang-nhap'), 100);
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      // this.$message.error(msg);
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      // this.$message.error(msg);
      window.getApp.$router.push('/forbidden');
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      // this.$message.success(msg);
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      window.getApp.snackbar = {
        show: true,
        color: 'success',
        text: msg
      };
    }
  },
  {
    name: 'APP_RESOURCE_FAILED',
    // @error api response data
    callback: function (msg) {
      window.getApp.snackbar = {
        show: true,
        color: 'error',
        text: msg
      };
    },
  },
  {
    name: 'APP_LOADING',
    // @error api response data
    callback: function (val) {
      this.appLoading = val;
    },
  },
  {
    name: 'APP_NOTIFY',
    // @error api response data
    callback: function (msg) {
      window.getApp.snackbar = {
        show: true,
        timeout: 6000,
        color: '#3E8AEB',
        text: msg
      };
    }
  },
  {
    name: 'APP_NAVIGATE',
    callback: function (viewName) {
      const item = _.find(paths, {name: viewName})
      if(item) {
        window.getApp.$router.replace({ path: item.path });
      }
    }
  },
  {
    name: 'PRE_SAVE_DATA',
    callback: function () {
      if(this.$refs.form.validate()) {
        this.$root.$emit('REQUEST_SAVE_DATA');
      }
    }
  },
  {
    name: 'OTHER_ACTION',
    callback: function () {
      this.$root.$emit('REQUEST_OTHER_ACTION');
    }
  },
  {
    name: 'REQUEST_REFRESH_DATA',
    callback: function () {
      this.$root.$emit('REQUEST_REFRESH_DATA');
    }
  },
  {
    name: 'REQUEST_DELETE_DATA',
    callback: function (id, message = '') {
      window.getApp.delDialog = true;
      window.getApp.delId = id;
      window.getApp.delMessage = message;
    }
  },
];
